module.exports = __webpack_public_path__ + "img/img_member_ skill_brand@3x.fce81473.png";